<div class="close">
    <button (click)="close()">
        <app-svg use="close"></app-svg>
    </button>
</div>
<div class="search">
    <p class="search-title">{{ 'HEADER.SEARCH_TITLE' | translate }}</p>
    <form name="overlaySearch" (submit)="$event.preventDefault();goToSearch();">
        <input type="search"
               [placeholder]="'HEADER.SEARCH_PLACEHOLDER' | translate"
               name="searchTerms"
               (keydown)="searchByFormData()"
               id="SEARCH-overlay-input">
        <input type="button"
               (click)="goToSearch()"
               [value]="'HEADER.SEARCH_SUBMIT' | translate">
    </form>
    <div class="collected-results"
         *ngIf="results$ | async as result">
        <ng-container [ngSwitch]="result.state">
            <div *ngSwitchCase="'no-search'"></div>
            <app-svg use="circle-loading"
                     *ngSwitchCase="'pending'"></app-svg>
            <div class="error"
                 *ngSwitchCase="'error'">
                <p>{{ 'HEADER.SEARCH_ERROR' | translate }}</p>
                <button type="button"
                        (click)="searchByFormData()">{{ 'HEADER.SEARCH_ERROR_TRY_AGAIN' | translate }}</button>
            </div>
            <ng-container *ngSwitchCase="'success'">
                <span class="empty"
                      *ngIf="!(result?.results?.length > 0); else contentTemplate">{{ 'HEADER.SEARCH_EMPTY' | translate }}</span>
                <ng-template #contentTemplate>
                    <div ga4ViewItemList
                         [items]="result?.results | mapGA4Items"
                         [item_list_name]="'HEADER.PRODUCT_TITLE' | translate"
                         item_list_id="search-overlay">
                        <span class="title-result">{{ 'HEADER.PRODUCT_TITLE' | translate }}</span>
                        <ng-container *ngFor="let product of result?.results">
                            <a class="product"
                               ga4SelectItem
                               [name]="'HEADER.PRODUCT_TITLE' | translate"
                               id="search-overlay"
                               [items]="[product] | mapGA4Items"
                               [routerLink]="product?.url">
                                <span class="discount">{{ product?.splash != null ? product?.splash?.label : (product?.price?.listPrice?.amount > product?.price?.salesPrice?.amount ? ( 'K_PRIS_SPLASH' | translate ) : '') }}</span>
                                <img [use]="product?.images[0]"
                                     [alt]="product?.name"
                                     [query]="{width: 690, height:690, }">
                                <span class="brand">
                                    <span>{{ product?.designer }}</span>
                                    <span *ngIf="product?.designer && product?.brand">&nbsp;/&nbsp;</span>
                                    <span>{{ product?.brand }}</span>
                                </span>
                                <span class="title">{{ product?.name }}</span>
                                <span class="list-price"
                                      [attr.inert]="(product?.price?.listPrice?.amount??0) > (product?.price?.salesPrice?.amount??0) && product?.splash != null ?  null : ''">{{ 'PRODUCT_CARD.PRICE_LIST' | translate: {price: ((product?.price?.listPrice | price)) } }}</span>
                                <span class="sales-price">{{ (product?.id?.includes(',') ? 'PRODUCT_CARD.PRICE_SALES_CUSTOMIZER' : 'PRODUCT_CARD.PRICE_SALES_NO_CUSTOMIZER') | translate: {price: ((product?.price?.salesPrice | price)) } }}</span>
                                <span class="customizer"
                                      *ngIf="product?.id.includes(',') || product?.addon?.length > 0">
                                    <span><sup>+</sup>{{ 'PRODUCT_CARD.HAS_CUSTOMIZER' | translate }}</span>
                                </span>
                            </a>
                            <hr>
                        </ng-container>
                    </div>
                    <div></div>
                    <div></div>
                    <button class="submit"
                            (click)="goToSearch()">{{ 'HEADER.SEARCH_ALL_RESULTS' | translate }}</button>
                </ng-template>
            </ng-container>
        </ng-container>
    </div>
</div>
